module.exports = __webpack_public_path__ + "files/68537743d23b63655387918e39fe65c1.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Size4-Regular.woff
// module id = 1169
// module chunks = 60